<script>

import { bookDefaultCover, courseDefaultCover } from '../../config/values'

export default {
  props: {
    routename: {
      type: String
    },
    item: {},
    coverClass: {}
  },
  computed: {
    route () {
      return {
        name: this.routename,
        params: {
          id: this.item.id
        }
      }
    }
  },
  methods: {
    getThumbnail (src) {
      if (this.routename === 'bookDetail') {
        return this.$getThumbnail(src || bookDefaultCover, 0, 145)
      } else if (this.routename === 'courseDetail') {
        return this.$getThumbnail(src || courseDefaultCover, 0, 93)
      }
    }
  }
}
</script>

<template>
  <router-link :class="$style.item" :to="route">
    <img :class="[$style.cover, coverClass]" :src="getThumbnail(item.cover)" :alt="item.title" />
    <div :class="$style.name">{{item.name}}</div>
    <div :class="$style.author">{{item.author}}</div>
  </router-link>
</template>

<style lang="stylus" module>
.item
  display block

  /.name
    ellipsis()
    middle-font()
    margin 16px 0 1px

  /.author
    color $gray-500
    small-font()

  /.cover
    display block
    width 100%
    object-fit cover
</style>
